import styled from 'styled-components'

export const ScreenContainer = styled.div`
  width: 100%;
  padding: 0;
`

export const BreakWordParagraph = styled.p`
  word-wrap: break-word;
  overflow-wrap: break-word;
  margin: 0;
  padding: 0;
`
